import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import CalibrationPatternUseRequest from '../CalibrationPatternUseRequest/CalibrationPatternUseRequest.vue'
import PatternDetail from './components/details.vue'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.getInstitutions()
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.institutionId) {
      await Promise.all([
        this.getUnidades(),
        this.getUseRequestWaintingApproval(),
        this.getUseRequestApproved(),
        this.getManufacturers(),
      ])
    }

    this.updateTable()
  },

  data: () => ({
    institution: {},
    isInactive: false,
    detailKey: false,
    detailDialog: false,
    selectedPattern: {},
    visible: false,
    dialogKey: false,
    requestDialog: false,
    loading: false,
    unidadeLoading: false,
    institutionLoading: false,
    error: false,
    buttonDeleteVisible: false,
    requestApproval: false,
    requestApproved: false,
    expanded: [],
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    calibrationPatterns: [],
    currentCalibrationPattern: {},
    useRequestsWaintingApproval: [],
    useRequestsApproved: [],
    userLogged: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    totalItensOnPage: 0,
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      institutionId: null,
      unidadeId: null,
      propertyCode: null,
      manufacturer: null,
      serialNumber: null,
      model: null,
      alienated: false,
    },
    calibrationPatternName: null,
    calibrationPatternPropertyCode: null,
    calibrationPatternManufacturer: null,
    calibrationPatternSerialNumber: null,
    calibrationPatternModel: null,
    calibrationPatternAlienated: false,
    alienatedOptions: [
      { text: 'Todos', value: null },
      { text: 'Alienados', value: true },
      { text: 'Não alienados', value: false },
    ],
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Padrão',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Código Patrimônio',
        align: 'center',
        value: 'propertyCode',
      },
      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
      },
      {
        text: 'Nº Série',
        align: 'center',
        value: 'serialNumber',
      },
      {
        text: 'Validade',
        align: 'center',
        value: 'expirationDate',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Padrão',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    manufacturers: [],
  }),

  components: {
    CalibrationPatternUseRequest,
    PatternDetail,
  },

  methods: {
    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    addCalibrationPattern() {
      sessionStorage.clear()
      this.$router.push('/newCalibrationPattern')
    },

    detail(item) {
      this.selectedPattern = item
      this.detailKey = !this.detailKey
      this.detailDialog = true
    },

    editCalibrationPattern(calibrationPattern) {
      this.currentCalibrationPattern = calibrationPattern
      this.$router.push(
        `/editCalibrationPattern/${this.currentCalibrationPattern.id}`
      )
    },

    callListUseRequestApproved() {
      this.$router.push('/resquestApproved')
    },

    closeDialog() {
      this.requestDialog = false

      this.getUseRequestWaintingApproval()
    },

    uploadDocument(calibrationPattern) {
      sessionStorage.clear()
      this.currentCalibrationPattern = calibrationPattern
      sessionStorage.setItem(
        'calibrationPattern',
        JSON.stringify(this.currentCalibrationPattern)
      )
      this.$router.push({ path: '/uploadDocument' })
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.calibrationPatternName
      this.filter.propertyCode = this.calibrationPatternPropertyCode
      this.filter.manufacturer = this.calibrationPatternManufacturer
      this.filter.serialNumber = this.calibrationPatternSerialNumber
      this.filter.model = this.calibrationPatternModel
      this.filter.alienated = this.calibrationPatternAlienated
      this.updateTable()
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      await this.apiService
        .post('calibrationPattern/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.calibrationPatterns = response.content.calibrations
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.calibrations.length
          this.loading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getUseRequestWaintingApproval() {
      await this.apiService
        .get(`calibrationPattern/waintingApproval/${this.institutionId}`)
        .then((response) => {
          this.useRequestsWaintingApproval = response.content

          this.requestApproval =
            this.useRequestsWaintingApproval.length > 0 &&
            (this.userLogged.mainType == 0 ||
              this.userLogged.mainType == 1 ||
              this.institution.userType == 8 ||
              this.institution.userType == 2)
        })
    },

    async getUseRequestApproved() {
      await this.apiService
        .get(`calibrationPattern/approved/${this.institutionId}`)
        .then((response) => {
          this.useRequestsApproved = response.content

          this.requestApproved = this.useRequestsApproved.length > 0
        })
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        institutionId: this.institutionId,
        unidadeId: null,
        propertyCode: null,
        manufacturer: null,
        serialNumber: null,
        model: null,
        alienated: null,
      }
      this.institutionId = this.institutionId
      this.unidadeId = this.institution.userType > 1 ? this.unidadeId : null
      this.calibrationPatternName = null
      this.calibrationPatternPropertyCode = null
      this.calibrationPatternManufacturer = null
      this.calibrationPatternSerialNumber = null
      this.calibrationPatternModel = null
      this.calibrationPatternAlienated = null

      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
